import { SegmentType } from '@pages/types';
import { Row, Text, colors, Col, Button } from 'common-components';
import { css } from '@emotion/react';
import { useAppTranslation } from '@hooks';
import { AssignManager } from '@views/shared/manager';
import { AssignContributor } from '@views/shared/contributor';

import { HeaderSegment, StepHeading } from '../HeaderSegment';

type ManualPropsType = {
  step: number
  segment: SegmentType
  onUpdateManagers: (managersShort: SegmentType['managersShort']) => void
  onUpdateContributors: (contributorsShort: SegmentType['contributorsShort']) => void
};

const ManualSegment = ({
  step,
  segment,
  onUpdateContributors,
  onUpdateManagers,
}: ManualPropsType) => {
  const { translate } = useAppTranslation();

  return (
    <div>
      <HeaderSegment type={10} name={segment.name} />
      {step === 2 && (
        <>
          <Row justify={'space-between'} align={'middle'}>
            <Col
              css={css`
                display: flex;
                flex-direction: column;
              `}
            >
              <StepHeading step={2} title={translate('createSegment.addUsers')} />
            </Col>
            <Col
              css={css`
                display: flex;
                gap: 8px;
              `}
            >
              <Button size="lg" iconLeft="Download01">{translate('createSegment.users')}</Button>
              <Button size="lg" iconLeft="Upload01">{translate('createSegment.import')}</Button>
            </Col>
          </Row>
          <AssignContributor onUpdateContributors={onUpdateContributors} />
        </>
      )}
      {step === 3 && (
        <>
          <Row justify={'space-between'} align={'middle'}>
            <Col
              css={css`
                display: flex;
                flex-direction: column;
              `}
            >
              <StepHeading step={3} title={translate('createSegment.chooseManagers')} />
            </Col>
          </Row>
          <AssignManager
            managersUser={segment.managersShort}
            onUpdateManagers={onUpdateManagers}
            modifEnabled={true}
          />
        </>
      )}
    </div>
  );
};

export default ManualSegment;
